module.exports = __webpack_public_path__ + "img/478536.7767958d.svg";